export interface FailedStep {
    /** What ninja prints on the `FAILED:` line. */
    target: string;
    command: string;
    /** What the command printed, e.g. the compiler's errors. */
    output: string;
}

/**
 * The failed steps in ninja's output. Ninja prints a `FAILED:` line, the
 * command, then the command's output, up to its next status line.
 */
export function failedSteps(output: string): FailedStep[] {
    const steps: FailedStep[] = [];
    let current: string[] | undefined;
    const finish = () => {
        if (current === undefined) return;
        const [failed = "", command = "", ...printed] = current;
        steps.push({
            target: failed.slice("FAILED: ".length).trim(),
            command,
            output: printed.join("\n").trimEnd(),
        });
        current = undefined;
    };
    for (const line of output.split("\n")) {
        if (line.startsWith("FAILED: ")) {
            finish();
            current = [line];
        } else if (current !== undefined) {
            if (NINJA_STATUS.test(line)) finish();
            else current.push(line);
        }
    }
    finish();
    return steps;
}

const NINJA_STATUS = /^(\[\d+\/\d+\] |ninja: )/;
